//@flow
import {
  EditSpotLightQuery,
  EditSpotLightQueryMsg,
  GetSpotLightQuery,
  GetSpotLightQueryMsg
} from '../../autogenerated/ZoomBridge';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import ErrorHandler from '../../error/ErrorHandler';
import { SPOTLIGHT_CONTENT } from '../../store/Constants';
import Store from '../../store/Store';
import { toast } from '../../store/StoreUtil';
import t from '../../i18n/I18n';

const debug = require('../../debug/debug')('wc:queries:SpotlightUtil');

export default class SpotlightUtil {
  static getSpotlightContentQuery(callback: ?function): void {
    const getSpotLightQuery = new GetSpotLightQuery();
    const msg = new GetSpotLightQueryMsg();
    getSpotLightQuery.message = msg;
    getSpotLightQuery.run().then((resp, error) => {
      if (error) {
        ErrorHandler.handleError(error);
        Store.put(SPOTLIGHT_CONTENT, null);
      } else {
        if (callback) callback(this.parseSpotlightQuery(resp));
        Store.put(SPOTLIGHT_CONTENT, this.parseSpotlightQuery(resp));
      }
    });
  }

  static parseSpotlightQuery(data: Object): Array {
    let items: Array = [];
    _.each(data._spotLightDetails, (item) => {
      const name = item._path
        .split('\\')
        .pop()
        .split('/')
        .pop();
      items.push({
        name: name,
        imageUrl: ThumbnailUtil.getThumnailUrl(true, item.getBid(), item.getFuid(), item.getRrn(), name),
        description: item._overlayText,
        actionTime: item.getPrettyTime(),
        _fuid: item._fuid,
        id: item._spotLightId,
        _fqPath: item._path,
        _isFile: item._file,
        _mtime: item._mtime
      });
    });
    return items;
  }

  static removeSpotLightQuery(spotlightId: number, fuid: number): void {
    const query = new EditSpotLightQuery();
    const msg = new EditSpotLightQueryMsg();
    msg.setSpotLightId(spotlightId);
    msg.setFuid(fuid);
    msg.setOperationType('DELETE');
    query.message = msg;
    query.run().then(
      (resp) => {
        this.getSpotlightContentQuery();
      },
      (error) => {
        ErrorHandler.handleError(error);
      }
    );
  }

  static addSpotLightQuery(fuid: number, text: string): void {
    const query = new EditSpotLightQuery();
    const msg = new EditSpotLightQueryMsg();
    msg.setFuid(fuid);
    msg.setOverlayText(text);
    msg.setOperationType('ADD');
    query.message = msg;
    query.run(true).then(
      (resp) => {
        this.getSpotlightContentQuery();
      },
      (error) => {
        if (!error) {
          toast(t('INVALID_STATE_TEXT'));
        } else {
            ErrorHandler.handleError(error);
          // toast(error.toString());
        }
        //  ErrorHandler.handleError(error);
      }
    );
  }
}
